import WasmController from "react-lib/frameworks/WasmController";
import * as MainCheckInI from "./MainCheckInInterface";
import * as MainHISI from "HIS/MainHISInterface";

export default class MainCheckInController extends WasmController<
  MainCheckInI.State,
  MainCheckInI.Event,
  MainCheckInI.Data,
  MainCheckInI.Props
> {
  constructor(
    getState: () => MainCheckInI.State,
    setState: <K extends keyof MainCheckInI.State>(
      state:
        | ((
            prevState: Readonly<MainCheckInI.State>,
            props: Readonly<MainCheckInI.Props>,
          ) => Pick<MainCheckInI.State, K> | MainCheckInI.State | null)
        | (Pick<MainCheckInI.State, K> | MainCheckInI.State | null),
      callback?: () => void,
    ) => void,
    window: any,
  ) {
    super(getState, setState, window, MainCheckInI.DataInitial);
  }

  handleEvent = (e: MainCheckInI.Event) => {
    console.log("[CheckIn] handleEvent:", e.message, (e as any).params);

    switch (e.message) {
      case "RunSequence":
        return MainHISI.RunSequence(this as any, e.params);

      case "HandleLoginSuccess":
        return MainHISI.HandleLoginSuccess(this as any, e.params);

      case "ScanQR":
        return MainCheckInI.ScanQR(this as any, e.params);

      case "CheckPackage":
        return MainCheckInI.CheckPackage(this as any, e.params);

      case "CheckAppointment":
        return MainCheckInI.CheckAppointment(this as any, e.params);

      case "NotifyMobileQRCheckIn":
        return MainCheckInI.NotifyMobileQRCheckIn(this as any);

      case "GetPatientCurrentEncounter":
        return MainCheckInI.GetPatientCurrentEncounter(this as any, e.params);

      case "BackToLobby":
        return MainCheckInI.BackToLobby(this as any);

      default:
        console.warn("[CheckIn] Unknown event:", (e as any).message);
    }
  };
}
